import styled from 'styled-components';

import { colors } from '@creditornot/cb-ingredients';
import { color } from '@creditornot/cb-ingredients/design-tokens';

import { Typography as T } from '../Typography/Typography';

const Root = styled(T.footnoteLabel)`
  display: flex;
  background: ${colors.banana100};
  padding: 4px;
  justify-content: center;
  color: ${color.textInverse};
`;

const localHostnames = ['localhost', '127.0.0.1'];

const isLocalhost = localHostnames.includes(window.location.hostname);

type Props = {
  className?: string;
};

export const AppEnvWarning = ({ className }: Props) => {
  if (!isLocalhost || import.meta.env.VITE_APP_ENV !== 'production') return null;

  return (
    <Root className={className}>
      <T.footnoteLabel>VITE_APP_ENV is set to production</T.footnoteLabel>
    </Root>
  );
};
